/** Interrupteur du mode rafale : bien visible, un toucher pour l'activer ou le couper. */
import { Zap } from 'lucide-react';
import { useBurst } from '@/features/stock-mode/burst/BurstProvider';
import { cn } from '@/lib/utils';

export function BurstToggle({ className }: { className?: string }) {
  const { enabled, setEnabled } = useBurst();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label="Mode rafale"
      data-testid="burst-toggle"
      onPointerDown={(event) => event.preventDefault()}
      onClick={() => setEnabled(!enabled)}
      className={cn(
        'flex h-11 shrink-0 items-center gap-1 rounded-full border-2 px-3 text-sm font-bold',
        enabled
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border bg-card text-muted-foreground',
        className,
      )}
    >
      <Zap className={cn('h-4 w-4', enabled && 'fill-current')} />
      Rafale
    </button>
  );
}
